import { Badge } from "../ui/badge";

interface StatusBadgeProps {
  status: string;
  statusBucket?: string;
}

// PENDING_SUBMISSION (EHR codes 11/12/17) used to normalize to
// READY_FOR_REVIEW; keep it borderless so those rows keep their existing
// non-emphasised look now that the backend gives them their own bucket.
const BORDERLESS_BUCKETS = [
  "COMPLETED",
  "QUEUED",
  "READY_FOR_REVIEW",
  "PENDING_SUBMISSION",
];

export function StatusBadge({ status, statusBucket }: StatusBadgeProps) {
  const variant = status === "Late" ? "destructive" : "secondary";
  const showBorder = statusBucket ? !BORDERLESS_BUCKETS.includes(statusBucket) : false;

  return (
    <Badge variant={variant} className={showBorder ? "border-2 border-primary" : undefined}>
      {status}
    </Badge>
  );
}
